import cn from "clsx";
import { useTranslations } from "next-intl";
import { forwardRef, InputHTMLAttributes } from "react";

interface CheckBoxProps extends InputHTMLAttributes<HTMLInputElement> {
  labelKey?: string;
  label?: string | any;
  className?: string;
  labelClassName?: string;
  inputClassName?: string;
}
export const CheckBox = forwardRef<HTMLInputElement, CheckBoxProps>(
  ({ labelKey, label, className, labelClassName, inputClassName, ...rest }, ref) => {
    const t = useTranslations();
    return (
      <label className={cn("group flex cursor-pointer items-center text-sm", className)}>
        <input
          name={labelKey ?? label}
          type="checkbox"
          className={cn(
            "form-checkbox hover:border-grey checked:bg-grey checked:hover:bg-grey checked:focus:bg-grey border-grey-40 size-5 cursor-pointer rounded border transition duration-500 ease-in-out focus:outline-none focus:ring-0 focus:ring-offset-0 focus-visible:outline-none",
            inputClassName,
          )}
          ref={ref}
          {...rest}
        />
        <span className={cn("ms-2", labelClassName)}>{labelKey ? t(labelKey) : label}</span>
      </label>
    );
  },
);

CheckBox.displayName = "CheckBox";
